/**
 * AGENCJI NIE MA NIGDZIE (Piotr 27.09 i 5.10; SRCH-STALE-01 w docs/SerpZachowania.md).
 * Lista, piny, licznik, histogram cen i e-maile z alertami biorą tylko ogłoszenia prywatne i
 * nierozstrzygnięte.
 *
 * To STAŁA część zapytania (`applySerpFilters`, `useHistogramCen`), nie filtr: do 7.10 warunek
 * siedział tylko w `DEFAULT_FILTERS.postingTypes`, więc każda droga, która budowała filtry od zera
 * („Wróć do Mojego wyszukiwania” z filtrami z profilu, SRCH-MOJE-09), wpuszczała agencje na listę.
 * Tu, w module zgodnym z Deno, bo tę samą ścieżkę odczytu bierze `send-filter-alerts`.
 */
export const RODZAJE_BEZ_AGENCJI: Array<'individual' | 'unclear'> = ['individual', 'unclear'];
